// extracted by mini-css-extract-plugin
module.exports = {"color-mischka":"#e0e1e7","colorMischka":"#e0e1e7","detailsHolder":"_2wvtY","detailsTitle":"CzqY_"};